import React from 'react';
import PropTypes from 'prop-types';
import { DropzoneDialogV2 } from '../DropzoneV2';

const DropzoneModalV2 = ({
  onSave,
  acceptedFiles,
  showPreviews,
  maxFileSize,
  filesLimit,
  onClose,
  open,
}) => (
  <DropzoneDialogV2
    open={open}
    onSave={onSave}
    onClose={onClose}
    acceptedFiles={acceptedFiles}
    maxFileSize={maxFileSize}
    filesLimit={filesLimit}
  />
);

DropzoneModalV2.propTypes = {
  onSave: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  acceptedFiles: PropTypes.array,
  showPreviews: PropTypes.bool,
  maxFileSize: PropTypes.number,
  filesLimit: PropTypes.number,
  files: PropTypes.array,
};

DropzoneModalV2.defaultProps = {
  acceptedFiles: ['image/jpeg', 'image/png', 'image/bmp'],
  showPreviews: true,
  maxFileSize: 5000000,
  filesLimit: 10,
  files: [],
};

export default DropzoneModalV2;
